import { auth0Config as mockConfig } from "../../__fixtures__/auth0/auth0Config";

export interface Auth0Config {
  auth0Tenant: string;
  authorizationServer: {
    issuer: string;
  };
  auth0Domain: string;
  clientID: string;
  callbackURL: string;
  internalOptions: {};
  extraParams: {
    login_hint?: string;
    prompt: string;
  };
  dict: {
    signin: {
      title: string;
    };
  };
}

declare global {
  interface Window {
    AUTH0CONFIG: Auth0Config;
  }
}

const auth0Config: Auth0Config =
  process.env.NODE_ENV === "production" ? window.AUTH0CONFIG : mockConfig;

export default auth0Config;
